let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i8IR3")).then(() => parcelRequire('kfDgS'));